import Header from 'assets/header.jpg';

function HeaderImage({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative w-full">
      <div className="relative">
        <img
          src={Header}
          alt="Header"
          className="absolute inset-0 size-full object-cover object-center"
          style={{ objectPosition: '100% 40%' }}
        />
        <div
          className="relative p-6 bg-blend-overlay md:p-8"
          style={{
            backgroundImage:
              'linear-gradient(to bottom, rgba(49, 81, 0, 0.7) 0%, rgba(15, 33, 58, 0.9) 100%)',
          }}
        >
          <div className="mx-auto max-w-7xl lg:py-10">
            <div className="max-w-4xl">
              <h1 className="mb-2 font-oswald text-2xl font-bold uppercase tracking-wide text-accentGreenBright sm:text-3xl md:text-4xl">
                Start a Trip
              </h1>
              <p className="mb-4 text-sm text-white sm:mb-6 sm:text-base md:text-lg">
                Easily book a hotel yourself, or rely on our experts for larger
                reservations.
              </p>
            </div>

            <div className="w-full">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeaderImage;
